import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { Envelope } from '../../../../../../types/graph-dialog.interface';
import { CesButtonSecondaryComponent } from '../../../../../ui/ces-buttons/ces-button-secondary.component';
import { GraphItemRowComponent } from './graph-item-row.component';

@Component({
  selector: 'app-envelope-manager',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslocoModule, CesButtonSecondaryComponent, GraphItemRowComponent],
  templateUrl: './envelope-manager.component.html',
})
export class EnvelopeManagerComponent {
  readonly envelopes = input.required<Envelope[]>();

  readonly addEnvelope = output<void>();
  readonly configureEnvelope = output<Envelope>();
  readonly removeEnvelope = output<Envelope>();
}
